import { Checkbox as MUICheckbox } from '@mui/material';

export type CheckedStatus = 'checked' | 'unchecked' | 'indeterminate';

interface CheckboxWithoutLabelProps {
    onToggled: (isChecked: boolean) => void;
    status: CheckedStatus;

    disabled?: boolean;
}

/** An alternative to our main `Checkbox` component. Mainly for use in tables or accordions where multiple checkboxes are labeled by a column name. */
export const CheckboxWithoutLabel = (props: CheckboxWithoutLabelProps) => {
    return (
        <MUICheckbox
            checked={props.status === 'checked'}
            disabled={props.disabled}
            indeterminate={props.status === 'indeterminate'}
            onChange={(event: React.FormEvent<HTMLInputElement>) => {
                props.onToggled(event.currentTarget.checked);
            }}
            sx={props.disabled ? { color: 'var(--hps-gray) !important' } : { color: 'var(--hps-dark-blue) !important' }}
        />
    );
};
